import ApplicationSerializer from 'cpc-license-manager/serializers/application';

export default class OrganizationSerializer extends ApplicationSerializer {
  attrs = {
    licenses: {
      serialize: false,
      deserialize: false,
    },
  };
}
